module.exports = __webpack_public_path__ + "static/img/case1.b8291e4c.jpg";